import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class CheckIn {

  static endpoints = {
    index: `${baseUrl}/check-in`,
  };

  static async bonus(payload) {
    return axios.post(this.endpoints.index, payload).then((response)=> response.data);
  };

  static async bonusCheck() {
    return axios.get(`${this.endpoints.index}/check-today`).then((response)=> response.data);
  };

  static async getProgress() {
    return axios.get(`${this.endpoints.index}/progress`).then((response)=> response.data.progress);
  }

  static async getRewards() {
    return axios.get(`${this.endpoints.index}/rewards`).then((response)=> response.data.rewards);
  }

}

